
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private storage: Storage | null = null;
  private storageSub = new Subject<string>();
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.storage = window.localStorage;
    }
  }

  set(key: string, value: unknown): boolean {
    if (!this.isBrowser || value === undefined || value === null) return false;
    this.storage!.setItem(key, JSON.stringify(value));
    this.storageSub.next(key);
    return true;
  }

  watchStorage() {
    return this.storageSub.asObservable();
  }

  get<T = any>(key: string): T | null {
    if (!this.isBrowser) return null;
    const raw = this.storage!.getItem(key);
    if (!raw) return null;
    try { return JSON.parse(raw) as T; } catch { return null; }
  }

  remove(key: string): boolean {
    if (!this.isBrowser) return false;
    this.storage!.removeItem(key);
    this.storageSub.next(key);
    return true;
  }

  clear(): boolean {
    if (!this.isBrowser) return false;
    this.storage!.clear();
    return true;
  }
}
